/**
 * Labstep
 *
 * @module core/DataGrid/CellRenderer
 * @desc Generic CellRenderer parent component
 */

import { DataGridCellRendererActionMenu } from 'labstep-web/core/DataGrid/CellRenderer/ActionMenu';
import { DataGridCellRendererFile } from 'labstep-web/core/DataGrid/CellRenderer/File';
import { DataGridCellRendererMultiSelect } from 'labstep-web/core/DataGrid/CellRenderer/MultiSelect';
import { DataGridCellRendererRowNumber } from 'labstep-web/core/DataGrid/CellRenderer/RowNumber';
import type { Entity } from 'labstep-web/models/entity.model';
import React from 'react';
import type { ICellRendererActionMenuProps } from './ActionMenu/types';
import type { ICellRendererFileProps } from './File/types';
import type { ICellRendererMultiSelectProps } from './MultiSelect/types';
import type { ICellRendererRowNumberProps } from './RowNumber/types';

export class DataGridCellRenderer extends React.Component {
  public static File: React.FC<ICellRendererFileProps<Entity>>;

  public static MultiSelect: React.FC<
    ICellRendererMultiSelectProps<Entity>
  >;

  public static RowNumber: React.FC<
    ICellRendererRowNumberProps<Entity>
  >;

  public static ActionMenu: RFC<ICellRendererActionMenuProps<Entity>>;
}

DataGridCellRenderer.ActionMenu = DataGridCellRendererActionMenu;
DataGridCellRenderer.File = DataGridCellRendererFile;
DataGridCellRenderer.MultiSelect = DataGridCellRendererMultiSelect;
DataGridCellRenderer.RowNumber = DataGridCellRendererRowNumber;
